import { Close } from "@mui/icons-material";
import { Dialog, DialogTitle, IconButton } from "@mui/material";
function CustomDialog({
  fullWidth,
  children,
  maxWidth,
  open,
  onClose,
  dialogTitle,
  transition,
  paperPropsSx,
  ...rest
}) {
  return (
    <Dialog
      TransitionComponent={transition}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { ...paperPropsSx }
      }}
      {...rest}
    >
      <DialogTitle sx={{ marginBottom: 0 }}>{dialogTitle}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{ position: "absolute", top: 8, right: 8, ml: 2 }}
      >
        <Close />
      </IconButton>
      {children}
    </Dialog>
  );
}

export default CustomDialog;
